<template>
  <div class="language-switcher" @click="switchHandler">
    <span :class="lang === 'zh' ? 'selected' : ''">中</span>
    |
    <span :class="lang === 'en' ? 'selected' : ''">En</span>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {}
  },
  computed: {
    lang: {
      get() {
        return this.$store.state.app.language
      },
      set(lang) {
        // this.$store.dispatch('app/setLanguage', lang)
        this.$store.commit('setLanguage', lang)
      }
    }
  },
  watch: {},
  created() {
    // //多语言切换全局事件
    // let _self = this
    // let switchEvent= new Event('switchHandler')
    // window.addEventListener("switchHandler", (event) => {
    //   window.lang = _self.lang
    // })

    // window.onSwitchHandler = function(lang){
    //   window.dispatchEvent(switchEvent)
    // }
  },
  mounted() {},
  destroyed() {},
  methods: {
    switchHandler: function() {
      if (this.lang === 'en') {
        // 切换到中文语言
        this.$i18n.locale = 'zh'
        this.lang = 'zh'
      } else {
        // 切换到英文语言
        this.$i18n.locale = 'en'
        this.lang = 'en'
      }

      // window.onSwitchHandler(this.lang)
    }
  }
}
</script>
<style scoped>
.language-switcher {
  color: #cccccc;
  cursor: pointer;
}

.selected {
  color: #0f3fbc;
}
</style>
